import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App.js'
import { ThemeProvider } from './components/ThemeProvider.js'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
